// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './filters';
import './components';

Vue.config.productionTip = false;

/* eslint-disable no-new */
window.App = new Vue({
  el: '#qsuper-modeller',
  router,
  store,
  template: '<App/>',
  components: { App },
});
